<template>
  <div class="lebot">
    <top-bar hide-top="true"/>
    <div class="content">
      <div class="container-fluid" :class="{'sel-contato': dados.id}">
        <div class="row">
          <div class="col-md-5 col-xl-4 p-0 bg-white lebot-contatos">
            <div class="bg-light py-2 pl-3 pr-2 lebot-header">
              <div class="d-flex align-items-center">
                <div class="mr-3" v-if="operator">
                  <img :src="operator.logo || 'https://img.freepik.com/vetores-premium/icone-do-robo-design-de-sinal-de-bot-conceito-de-simbolo-de-chatbot-servico-de-suporte-por-voz-bot-bot-de-suporte-on-line-estoque-ilustracao-vetorial_100456-34.jpg'" class="img-perfil">
                </div>
                <div class="w-100">
                  <h6 class="mb-0 text-ellipsis">
                    <span class="mr-1">{{ operator_name }}</span>
                    <i class="fa fa-pencil-alt small text-primary" @click="alterOperator()" v-if="operator.master"></i>
                  </h6>
                  <div class="small">{{ operator.business_name }}</div>
                </div>
                <button class="btn" @click="novaConversa()" title="Novo chat">
                  <i class="fa fa-user-plus text-secondary"></i>
                </button>
                <button class="btn d-md-none" @click="$emit('toggleMenu')">
                  <i class="fa fa-ellipsis-v text-secondary"></i>
                </button>
              </div>
            </div>
            <div class="lebot-contatos-body">
              <loading v-if="load" class="pt-5"/>
              <div v-else>
                <div class="p-3 small" style="background-color: #FCD279" v-if="!connected">
                  <h6 class="mb-1">LeBot Desconectado!</h6>
                  <div class="small">
                    Certifique-se que está conectado á internet. <a href="javascript:" class="text-dark" @click="reloadPage()"><u>Reconectar</u></a>
                  </div>
                </div>
                <div class="p-2 border-bottom d-flex justify-content-between align-items-center">
                  <div class="rounded position-relative w-100" style="background-color: #F0F2F5">
                    <div v-if="!filter">
                      <i class="fa fa-search small" style="position: absolute; top: 12px; left: 16px"></i>
                      <input id="atendiment" type="search" placeholder="Pesquisar contato" @search="searchContacts()" v-model="search.contact_name"
                          class="form-control border-0 rounded pl-5 bg-lebot"/>
                    </div>
                    <div v-else>
                      <select class="form-control bg-lebot" v-model="search.departament_id" @change="filterContacts(false)">
                        <option value="">Todos departamentos</option>
                        <option :value="d.id" v-for="d in departaments">{{ d.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="d-flex text-center pl-2">
                    <button class="btn mr-1" title="Filtrar atendimentos" @click="toggleFilter">
                      <i class="fa fa-list"></i>
                    </button>
                    <button class="btn btn-primary" @click="searchContacts()"><i class="fa fa-search"></i></button>
                  </div>
                </div>
                <a href="javascript:" class="lebot-contact text-dark text-decoration-none" :class="{'selected': dados.id == c.id}"
                             v-for="c in contacts" :key="c.id" @click="goContact(c.id)">
                  <div class="d-flex justify-content-between align-items-start" :class="{'bold': c.new_messages > 0}">
                    <div class="lebot-contact-body">
                      <h6 class="mb-1 text-ellipsis">
                        <span v-if="c.name || c.profile">{{ c.name || c.profile }}</span>
                        <span v-else>{{ c.wa_id | phone }}</span>
                      </h6>
                      <div>
                        <p class="lebot-contact-msg text-ellipsis" v-if="c.last_message">
                          <span v-if="c.last_message.type !== 'text'">
                            <span v-if="c.last_message.type === 'media' && c.last_message.media.type === 'audio'"><i class="fas fa-headphones"></i> Áudio</span>
                            <span v-else-if="c.last_message.type === 'media' && c.last_message.media.type === 'image'"><i class="fas fa-camera"></i> Imagem</span>
                            <span v-else-if="c.last_message.type === 'media' && c.last_message.media.type === 'video'"><i class="fas fa-video"></i> Vídeo</span>
                            <span v-else-if="c.last_message.type === 'interaction'"><i class="fas fa-robot"></i> Lebot</span>
                            <span v-else><i class="fas fa-file-alt"></i> Documento</span>
                          </span>
                          <span v-else-if="c.last_message.text">{{ c.last_message.text }}</span>
                          <span v-else>&nbsp;</span>
                        </p>
                        <span class="badge text-primary border border-success mr-1" v-if="c.departament_name">{{ c.departament_name }}</span>
                        <span class="badge badge-success mr-1" v-if="c.status == 2">Aguardando</span>
                        <span class="badge badge-secondary mr-1" v-else-if="c.status == 3">Atendimento</span>
                      </div>
                    </div>
                    <div class="text-right">
                      <div class="small send-date" v-if="c.send_date || c.send_hour">
                        {{ c.send_date || c.send_hour }}
                      </div>
                      <div class="new-message-balao small" v-if="c.new_messages > 0">{{c.new_messages || 1}}</div>
                    </div>
                  </div>
                </a>
                <div class="d-flex justify-content-between align-items-center py-2" v-if="search.page > 0 || contacts.length >= 30">
                  <button class="btn btn-sm small" @click="paginateContacts(-1)" :disabled="search.page === 0"><i class="fa fa-angle-left"></i> Voltar</button>
                  <span class="small">Página: {{search.page + 1}}</span>
                  <button class="btn btn-sm small" @click="paginateContacts(1)" :disabled="contacts.length < 30">Próximo <i class="fa fa-angle-right"></i></button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-7 col-xl-8 p-0 lebot-conversa"
               @dragover.prevent
               @dragenter.prevent="onDragEnter"
               @dragleave.prevent="onDragLeave"
               @drop.prevent="onDrop"
               @paste="onPaste"
               tabindex="1">

            <div id="dropZone" class="drop-zone" :class="{ 'active': isDragging || file }" tabindex="2"
                 @keyup.esc="cancelDragging" @keyup.enter="sendFile">
              <div class="w-100">
                <p v-if="!file">Arraste o arquivo aqui ou clique para selecionar</p>
                <div v-else>
                  <div>
                    <img :src="previewUrl" class="img-preview" alt="Preview" v-if="file.type.startsWith('image/')"/>
                    <audio :src="previewUrl" controls v-else-if="file.type.startsWith('audio/')"></audio>
                    <div class="pdf-preview" v-else-if="file.type === 'application/pdf'">
                      <i class="fa fa-file-pdf fa-2x"></i>
                      <div class="mt-1">{{ file.name }}</div>
                    </div>
                  </div>
                  <hr>
                  <button class="btn btn-outline-danger mr-3" type="button" @click="file = null">
                    Cancelar
                  </button>
                  <button class="btn btn-primary" type="button" @click="sendFile()">
                    <i class="fa fa-paper-plane mr-1"></i> Enviar
                  </button>
                </div>
              </div>
            </div>
            <div v-if="dados.id">
              <div class="bg-light py-2 px-2 pl-3 lebot-header">
                <div class="d-flex align-items-center">
                  <div class="mr-3">
                    <a href="javascript:" class="text-decoration-none text-dark" @click="closeChat()">
                      <i class="fa fa-arrow-left text-secondary small pr-2 d-md-none"></i>
                      <img src="../assets/default-avatar.png" class="img-perfil">
                    </a>
                  </div>
                  <a href="javascript:" class="text-decoration-none text-dark" @click="chatEvent(3)">
                    <h6 class="mb-0">{{ dados.name || dados.profile }}</h6>
                    <div class="small">{{ dados.wa_id | phone }}</div>
                  </a>
                  <div class="ml-auto" v-show="!loadMsg">
                    <chat-toggle :dados="dados" @chatEvent="chatEvent"/>
                  </div>
                </div>
              </div>
              <div ref="conversaScroll" class="lebot-coversas-body" @scroll="onScroll">
                <loading v-if="loadMsg"/>
                <div v-else-if="messages.length">
                  <div id="lebotMessages" class="lebot-container-balao">
                    <div class="mb-1" :class="{'text-right': message.is_me}" v-for="(message, i) in messages" :id="'msg' + i">
                      <lebot-balao :m="message" :key="i" v-if="message" @openMedia="openMedia"/>
                    </div>
                  </div>
                  <!--<lebot-info :text="`Atendente responsável: ${dados.agent_name}`" v-if="dados.agent_id && dados.agent_id !== operator.id"/>-->
                  <a href="javascript:" class="text-decoration-none" @click="$swal('Quando passar mais de 24h desde que o cliente respondeu pela última vez, o WhatsApp libera apenas mensagems pré-aprovadas para inicio de novas conversas.')" v-if="!dados.available">
                    <lebot-info
                        text="Já se passaram mais de 24 horas desde que o cliente respondeu pela última vez."
                        type="exclamation-triangle"/>
                  </a>
                </div>
                <div v-if="!loadMsg && page > 1">
                  <button class="btn btn-secondary btn-scroll shadow" @click="scrollBottom()">
                    <i class="fa fa-chevron-down"></i>
                  </button>
                </div>
              </div>
              <div class="lebot-coversas-footer bg-lebot border-top">
                <list-emojis @addEmoji="addEmoji"/>
                <div v-if="dados.status == 3">
                  <div v-show="!isRecording">
                    <div class="d-flex align-items-center position-relative">
                      <button class="btn text-secondary mr-1" type="button" @click="$emit('toggleEmoji')" :disabled="!dados.available"><i class="far fa-smile"></i></button>
                      <textarea type="text" class="form-control border-0 campo-msg" placeholder="Mensagem"
                                id="campoMensagem"
                                v-model="message"
                                rows="1"
                                :disabled="!dados.available"
                                @focus="$emit('toggleEmoji', true)"
                                @keydown.enter.exact.prevent="prepareMsg()"
                                @keydown.enter.shift.exact.prevent="addLineMessage">
                      </textarea>
                      <button class="btn text-secondary ml-2" type="button" @click="anexarArquivo()" :disabled="!dados.available" title="Anexar"><i class="fa fa-paperclip"></i></button>
                      <button class="btn text-secondary mr-2" type="button" @click="selReplies()" :disabled="!dados.available" title="Mensagens rápidas"><i class="fa fa-bolt"></i></button>
                      <button class="btn btn btn-primary btn-send" type="button" @click="enviarMensagem()" :disabled="!dados.available" v-show="message">
                        <i class="fa fa-paper-plane" style="margin-left: -2px"></i>
                      </button>
                      <button class="btn btn btn-primary btn-send" type="button" @click="startRecording()" :disabled="!dados.available" v-show="!message">
                        <i class="fa fa-microphone"></i>
                      </button>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center" v-if="isRecording">
                    <div class="ml-2">
                      <i class="fa fa-microphone text-danger mr-2"></i>
                      <span class="small" style="font-family: monospace">{{ recordingTimeFormatted }} - 02:00</span>
                    </div>
                    <div>
                      <button class="btn btn-secondary" type="button" @click="cancelRecording()">
                        Cancelar
                      </button>
                      <button class="btn btn-primary" type="button" @click="$refs.capAudio.enviarAudio()">
                        <i class="fa fa-paper-plane mr-1"></i> Enviar
                      </button>
                    </div>
                  </div>
                </div>
                <div class="py-1 text-center" v-else>
                  <button class="btn btn-primary px-4" @click="entrarConversa()">
                    {{ dados.status == 2 && dados.available ? 'Aceitar atendimento' : 'Entrar na conversa' }}
                  </button>
                </div>
              </div>
            </div>
            <div class="lebot-welcome bg-light" v-if="!dados.id">
              <div class="text-center" style="max-width: 80%; margin-top: -32px">
                <div class="m-auto" style="max-width: 92px;">
                  <img src="../assets/icon.png" alt="Logo" style="width: 100%">
                </div>
                <p class="mt-4">Clique em um dos contatos para inciar uma conversa</p>
                <hr>
                <div>
                  <h6>Testar som</h6>
                  <a href="#" class="text-decoration-none text-info mr-3" @click.prevent="testarSom(1)"><i class="fa fa-volume-up"></i> Chamado</a>
                  <a href="#" class="text-decoration-none text-info" @click.prevent="testarSom(2)"><i class="fa fa-music"></i> Mensagem</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal @salvar="alterContact">
      <div v-if="dados.id">
        <div class="text-center">
          <div class="mb-3">
            <img src="../assets/default-avatar.png" style="width: 72px">
          </div>
          <h6 class="mb-0">{{ dados.name || 'Contato' }}</h6>
          <a :href="`https://wa.me/${dados.wa_id}`" target="_blank" class="text-primary text-decoration-none">
            <span class="small">{{ dados.wa_id | phone }}</span>
            <i class="fab fa-whatsapp ml-1"></i>
          </a>
          <div v-if="dados.agent_name">
            <span class="badge badge-dark"><i class="fa fa-headset mr-1"></i> {{dados.agent_name}}</span>
          </div>
        </div>
        <hr>
        <div class="mb-2">
          <label class="small font-weight-bold mb-0">Nome</label>
          <input type="text" v-model="dados.new_name" id="contactName" class="form-control" placeholder="Nome do contato">
        </div>
        <div>
          <label class="small font-weight-bold mb-0">Observações</label>
          <textarea v-model="dados.new_observation" id="contactObs" rows="10" class="form-control" placeholder="Observações do contato">
        </textarea>
        </div>
      </div>
    </modal>

    <modal-center :preview="true">
      <loading v-if="!menuModalCenter"/>
      <div v-if="menuModalCenter === 1">
        <transfer-chat :dados="dados" @close="$emit('closeModalCenter')" @atualizar="searchContacts"/>
      </div>
      <div v-else-if="menuModalCenter === 2">
        <modal-template :dados="dados" :session="session" @close="$emit('closeModalCenter')" @atualizar="selContact(dados.id, true)"/>
      </div>
      <div v-else-if="menuModalCenter === 3">
        <modal-template :session="session" @close="$emit('closeModalCenter')" @atualizar="searchContacts"/>
      </div>
      <div v-else-if="menuModalCenter === 4">
        <modal-replies @response="sendReply"/>
      </div>
    </modal-center>

    <modal-media/>
    <modal-file @receiveDocumentToSend="handleFile"></modal-file>
    <audio-capture ref="capAudio" @sendAudio="enviarAudio"/>
  </div>
</template>

<script>
import Loading from "../components/loading";
import LebotBalao from "@/components/LebotBalao";
import TopBar from "@/components/TopBar";
import LebotInfo from "@/components/LebotInfo";
import StatusToggle from "@/components/StatusToggle";
import ChatToggle from "@/components/ChatToggle";
import Modal from "@/components/Modal";
import ModalCenter from "@/components/ModalCenter";
import TransferChat from "@/components/TransferChat";
import ListEmojis from "@/components/ListEmojis";
import ModalMedia from "@/components/ModalMedia";
import ModalFile from "@/components/ModalFile";
import ModalTemplate from "@/components/ModalTemplate";
import AudioCapture from "@/components/AudioCapture";
import ModalReplies from "@/components/ModalReplies";

export default {
  name: 'LeBot',
  components: {
    ModalReplies,
    AudioCapture,
    ModalTemplate,
    ModalFile,
    ModalMedia,
    ListEmojis,
    TransferChat,
    ModalCenter, Modal, ChatToggle, StatusToggle, LebotInfo, TopBar, LebotBalao, Loading},

  data() {
    return {
      contacts: [],
      search: { departament_id: '', page: 0, contact_name: '' },
      load: true,
      loadMsg: false,
      loadPage: false,

      dados: { id: null },
      page: 0,
      messages: [],
      isRecording: false,
      intervalRecording: null,
      recordingTime: 0,
      isDragging: false,
      dragCounter: 0,
      previewUrl: null,
      file: null,
      lock: false,

      message: '',
      synctimeOut: null,
      connected: true,
      filter: false,
      departaments: [],
      offlineMsgs: [],

      menuModalCenter: 1,
    }
  },

  methods: {
    buscarContatos(callback) {
      this.$http.get('contacts', { params: this.search })
        .then(response => {
          this.load = false;
          if (response.data && response.data.length) {
            this.contacts = [];
            this.$nextTick(() => {
              this.contacts = response.data;
              this.notification();

              if (callback) {
                callback();
              }
            })
          }

        }, res => {
          this.load = false;
          console.log(res);
        });
    },

    searchContacts() {
      this.load = true;
      this.search.departament_id = '';
      this.contacts = [];
      this.search.page = 0;
      this.buscarContatos();
    },

    filterContacts() {
      this.search.contact_name = '';
      this.contacts = [];
      this.search.page = 0;
      this.buscarContatos();
    },

    toggleFilter() {
      this.filter = !this.filter;

      if (!this.filter) {
        this.search.departament_id = '';
        this.search.contact_name = '';
        this.buscarContatos();
      }
    },

    paginateContacts(index) {
      if ((this.search.page + index) >= 0) {
        this.load = true;
        this.search.page += index;
        this.buscarContatos();
      }
    },

    goContact(id) {
      if (!this.loadMsg && parseInt(this.$route.params.id || '0') !== id) {
        this.$router.push('/chat/' + id);
      }
    },

    selContact(id, load) {
      this.loadPage = false;
      this.messages = [];
      this.page = 0;
      this.cancelRecording();

      if (id && this.dados.id !== id) {
        this.dados = { id };
        let contact = this.contacts.find(c => c.id == this.dados.id);

        if (contact) {
          this.dados.name = contact.name || contact.profile;
          this.dados.wa_id = contact.wa_id;
        }
      }

      if (id) {
        this.getMessages(id, load);

      } else {
        this.dados = { id: null };
      }
    },

    paginateMessages() {
      if (this.loadPage || this.loadMsg || (this.messages.length / ((this.page + 1) * 30)) < 1) {
        return;
      }

      this.loadPage = true;
      this.page++;
      this.getMessages(this.dados.id, false);
    },

    getMessages(id, load) {
      if (load) {
        this.loadMsg = true;
      }

      this.$emit('toggleEmoji', true);
      this.$http.get(`messages/${id}?page=${this.page}`)
        .then(response => {
          this.$nextTick(() => {
            if (response.data && response.data.contact) {

              if (response.data.messages.length) {
                const messages = response.data.messages.reverse();

                if (this.page === 0) {
                  this.messages.push(...messages);

                  this.$nextTick(() => {
                    this.scrollBottom();

                    if (load) {
                      this.$helpers.focusElement('campoMensagem');
                    }
                  });

                } else {
                  // paginacao
                  const el = this.$refs.conversaScroll;
                  const oldScrollHeight = el.scrollHeight;
                  const oldScrollTop = el.scrollTop;
                  this.messages.unshift(...messages);

                  this.$nextTick(() => {
                    const newScrollHeight = el.scrollHeight;
                    const diff = newScrollHeight - oldScrollHeight;
                    el.scrollTop = oldScrollTop + diff;
                  });
                }
              }

              if (this.page === 0) {
                this.dados = {
                  ...response.data.contact,
                  new_name: '',
                  new_observation: '',
                  new_messages: 0
                };

                this.updateContact();
                this.notification();

                if (this.dados.agent_id === this.operator.id) {
                  this.$helpers.focusElement('campoMensagem');
                }
              }
            }
          });

          this.loadMsg = false;
          this.load = false;
          this.loadPage = false;

        }, res => {
          this.loadMsg = false;
          this.load = false;
          this.$swal(res.data.msg || "Não foi possível buscar as mensagens deste contato!");
        });
    },

    scrollBottom() {
      const el = this.$refs.conversaScroll;
      el.scrollTop = el.scrollHeight;
    },

    onScroll(e) {
      if (!this.lock) {
        this.lock = true;

        requestAnimationFrame(() => {
          if (e.target.scrollTop === 0) {
            this.paginateMessages();
          }

          this.lock = false;
        });
      }
    },

    keepFocus() {
      if (this.message.trim()) {
      }
      this.$helpers.focusElement('campoMensagem');
    },

    prepareMsg() {
      if (this.$helpers.isMobile()) {
        this.addLineMessage();

      } else {
        this.enviarMensagem();
      }
    },

    enviarMensagem(dataMessage, callback, file, mediaBase64) {
      if (!this.dados.available) {        
        return;
      }

      if (!dataMessage) {
        let text = this.message.trim();

        if ((!text && !file && !mediaBase64) || !this.dados.id) {
          return;
        }

        if (text) {
          text = `*${this.operator_name}:*\n${text}`;
        }

        const date = new Date();
        dataMessage = {
          id: null,
          is_me: 1,
          external_id: null,
          pending: true,
          status: '',
          message: text || null,
          mediaBase64: mediaBase64 || null,
          contact_id: this.dados.id,
          to: this.dados.wa_id,
          send_date: `${date.getHours()}:${date.getMinutes()}`,
          content: {
            version: 1,
            type: 'text',
            text
          }
        }

        if (!file && !mediaBase64 && this.dados.id === this.dados.id) {
          this.message = "";
          this.dados.new_messages = 0;
          this.messages.push(dataMessage);
          this.$nextTick(() => {
            this.$helpers.scrollView(`msg${this.messages.length - 1}`);
          });
        }
      }

      let data = {};
      let url = `messages/${dataMessage.contact_id}`;
      let headers = {};

      if (!file){
        data = {
          session: this.session,
          contact_id: dataMessage.contact_id,
          message: dataMessage.message,
          mediaBase64: dataMessage.mediaBase64
        }

      } else {
        data = new FormData();
        data.append('file', file);
        data.append('contact_id', dataMessage.contact_id);
        data.append('session', this.session);

        url += '/media';
        headers["Content-Type"] = "multipart/form-data";
      }

      const errorMsg = "Não foi possível enviar esta mensagem";

      this.$http.post(url, data, {...headers})
        .then(res => {          
          if (res.data && res.data.id) {
            if (file || data.mediaBase64) {
              this.selContact(this.dados.id, true);

            } else {
              dataMessage.external_id = res.data.id;
            }

            if (callback) {
              callback();
            }

            this.updateContact();

          } else {
            this.loadMsg = false;
            this.$swal(res.data.msg || errorMsg);
            this.selContact(this.dados.id, true);
          }

        }, res => {
          this.loadMsg = false;

          if (res.status) {
            this.$swal(res.data.msg || errorMsg);

          } else {
            this.offlineMsgs.push(dataMessage);
          }
        });
    },

    startRecording() {
      this.message = '';
      this.isRecording = true;
      this.$refs.capAudio.startRecording();
      this.intervalRecording = setInterval(() => {
        this.recordingTime++;
      }, 1000);
    },

    cancelRecording() {
      this.recordingTime = 0;

      if (this.isRecording) {
        this.$refs.capAudio.cancelar();
      }

      if (this.intervalRecording) {
        clearInterval(this.intervalRecording);
      }
    },

    enviarAudio(mediaBase64) {
      this.isRecording = false;
      this.cancelRecording();

      if (mediaBase64) {
        this.loadMsg = true;
        this.enviarMensagem(null, null, null, mediaBase64);
      }
    },

    addLineMessage() {
      this.message += '\n';
      const campoMsg = document.getElementById('campoMensagem');

      if (campoMsg) {
        document.getElementById('campoMensagem').scrollTop = campoMsg.scrollHeight;
      }
    },

    addEmoji(e) {
      this.message += e;
    },

    chatEvent(event) {
      if (this.loadMsg) {
        return;
      }

      this.$emit('toggleEmoji', false);

      switch (event) {
        case 1:
          this.dados.step = 1;
          this.dados.status = 1;
          this.dados.departament_id = null;
          this.dados.message = `*Mensagem Automática*\nO atendente *${this.operator_name}* encerrou este atendimento`
          this.setContact(() => {
            this.selContact(this.dados.id, true);
          });
          break;
        case 2:
          this.dados.clear_chat = true;
          this.messages = [];
          this.setContact(() => {
            this.buscarContatos(() => {
              this.$router.push('/chat');
            });
          });
          break;
        case 3:
          this.dados.new_name = this.dados.name || this.dados.profile;
          this.dados.new_observation = this.dados.observation;
          this.$emit('openModal');
          this.$helpers.focusElement('contactName');
          break;
        case 4:
          this.menuModalCenter = 1;
          this.$emit('openModalCenter');
          break;
      }
    },

    novaConversa() {
      this.$router.push('/chat');
      this.menuModalCenter = null;
      this.$emit('openModalCenter');

      setTimeout(() => {
        this.menuModalCenter = 3;
      }, 1000)
    },

    entrarConversa() {
      if (!this.dados.available) {
        this.menuModalCenter = 2;
        this.$emit('openModalCenter');
        return;
      }

      this.dados.status = '3';
      this.dados.message =  `*Mensagem Automática*\nO atendente *${this.operator_name}* entrou na conversa`;

      this.setContact(() => {
        this.$helpers.focusElement('campoMensagem');
      });
    },

    setStatus(status) {
      this.dados.status = status;
      this.setContact();
    },

    setContact(callback) {
      this.$http.post('contacts', this.dados)
        .then(res => {
          if (res.data.success) {
            if (callback) {
              callback();
            }

            this.updateContact();

          } else if (res.data.msg) {
            this.$swal(res.data.msg || 'Erro ao atualizar contato');
          }

        }, res => {
          this.load = false;
          this.$swal('Erro ao atualizar o status deste contato!')
          this.dados.status = status;
        });
    },

    moveItem(contact) {
      const element = contact;
      const index = this.contacts.findIndex(c => c.id === contact.id);

      if (index >= 0) {
        this.contacts.splice(index, 1);
        this.contacts.splice(0, 0, element);
      }
    },

    notification() {
      let count = 0;
      count += this.contacts.reduce((acc, obj) => { return acc + (obj.new_messages || 0) }, 0);
      document.title = count > 0 ? `(${count}) LeBot` : 'LeBot';
    },

    reloadPage() {
      window.location.reload();
    },

    alterContact(callback) {
      callback(true);
      this.dados.name = this.dados.new_name;
      this.dados.observation = this.dados.new_observation;
      this.dados.message = null;

      let contact = this.contacts.find(c => c.id == this.dados.id);

      if (contact) {
        contact.name = this.dados.name;
      }

      this.setContact();
    },

    getDepartaments() {
      this.$http.get('departaments')
        .then(response => {
          this.departaments = response.data || [];

        }, res => {
          console.log(res);
        });
    },

    checkNotification() {
      if (this.canPlay) {
        const contact = this.contacts.find(c => c.status == 2);

        if (contact) {
          if (contact.departament_id && !this.operator.departaments.includes(contact.departament_id)) {
            return;
          }

          this.playNotification();

          this.$swal({
            text: "Nova solicitação de atendimento",
            buttons: ["Voltar", "Visualizar!"],
            dangerMode: true
          }).then((res) => {
            if (res) {
              if (this.$route.params.id != contact.id) {
                this.$router.push('/chat/' + contact.id);

              } else {
                this.selContact(contact.id, true);
              }
            }

            this.pauseNotification();
          });

        } else {
          this.pauseNotification();
        }
      }
    },

    sendOffilineMsgs() {
      if (this.offlineMsgs.length) {
        this.enviarMensagem(this.offlineMsgs[0], () => {
          this.offlineMsgs.splice(0, 1);
          this.sendOffilineMsgs();
        });

      } else if (this.dados.id) {
        this.selContact(this.dados.id);
      }
    },

    closeChat() {
      if (this.$route.name !== 'Lebot') {
        this.$router.push('/chat');

      } else {
        this.dados = { id: null }
      }
    },

    checkOffline() {
      this.$swal({
        text: "Algumas mensagens não foram enviadas. Ao trocar de conversa você poderá perde-las.",
        buttons: ["Aguardar", "Sair"],
        dangerMode: true
      }).then((res => {
        if (res) {
          this.offlineMsgs = [];
          this.dados = { id: null }
        }
      }));
    },

    updateContact() {
      const contact = this.contacts.find(c => c.id === this.dados.id);

      if (contact) {
        contact.new_messages = this.dados.new_messages;
        contact.status = this.dados.status;
        contact.departament_id = this.dados.departament_id;
        contact.departament_name = this.dados.departament_name;
        contact.agent_id = this.dados.agent_id;
      }
    },

    openMedia(url) {
      this.$emit('openModalMedia', url);
    },

    anexarArquivo() {
      this.$emit('openModalFile');
    },

    onPaste(e) {
      const items = (e.clipboardData || window.clipboardData).items
      if (!items) return

      for (let i = 0; i < items.length; i++) {
        const item = items[i]

        if (item.kind === 'file') {
          const file = item.getAsFile()
          if (!file) continue

          // valida tipo e tamanho (5MB)
          if (!this.isValidFile(file)) return

          e.preventDefault();
          this.handleFile(file);
          break
        }
      }
    },

    sendFile(){
      if (this.file) {
        this.loadMsg = true;
        const file = this.file;
        this.enviarMensagem(null, null, file);
        this.file = null;
      }
    },

    handleFileChange(e) {
      const file = e.target.files[0];

      if (!file) return;
      if (!this.isValidFile(file)) return;

      this.handleFile(file);
    },

    handleFile(file) {
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl)
        this.previewUrl = null
      }

      this.file = file;
      this.$nextTick(() => {
        this.$helpers.focusElement('dropZone');
      });

      // gera preview apenas para tipos suportados
      if (file.type.startsWith('image/') || file.type.startsWith('audio/')) {
        this.previewUrl = URL.createObjectURL(file);

      } else if (file.type === 'application/pdf') {
        this.previewUrl = null;
      }
    },

    onDragEnter(e) {
      if (this.dados.status != 3 || this.load || this.loadMsg || !e.dataTransfer.types.includes('Files')) return;

      this.dragCounter++;
      this.isDragging = true;
    },

    onDragLeave() {
      this.dragCounter--;

      if (this.dragCounter <= 0) {
        this.dragCounter = 0
        this.isDragging = false
      }
    },

    onDrop(e) {
      if (this.dados.status != 3 || this.load || this.loadMsg) return;

      this.dragCounter = 0;
      this.isDragging = false;
      const file = e.dataTransfer.files[0];

      if (this.isValidFile(file)) {
       this.handleFile(file);
      }
    },

    isValidFile(file) {
      if (!file) return false

      const validType =
          file.type.startsWith('image/') ||
          file.type.startsWith('audio/') ||
          file.type === 'application/pdf'

      if (!validType) {
        this.$swal("Arquivo não suportado. Envie imagem, áudio ou PDF.");
        return false
      }

      // valida tamanho
      const MAX_FILE_SIZE = 5 * 1024 * 1024 // 5 MB

      if (file.size > MAX_FILE_SIZE) {
        this.$swal('O arquivo deve ter no máximo 5 MB.')
        return false
      }

      return true
    },

    cancelDragging() {
      this.isDragging = false;
      this.previewUrl = null;
      this.file = null;
    },

    testarSom(som) {
      if (som === 1) {
        this.playNotification();

        setTimeout(() => {
          this.pauseNotification();
        }, 4000);

      } else {
        this.playNewMessage();
      }
    },

    selReplies() {
      this.menuModalCenter = 4;
      this.$emit('openModalCenter');
    },

    sendReply(response) {
      this.$emit('closeModalCenter');
      this.message = response;
      this.$nextTick(() => {
        this.enviarMensagem();
        this.$helpers.focusElement('campoMensagem');
      })
    },

    alterOperator() {
      this.$swal({
        text: 'Mudar o nome do agente em atendimento.',
        content: {
          element: "input",
          attributes: {
            placeholder: "Informe o nome",
            type: "text",
            className: 'form-control',
            maxLength: '16',
            value: this.operator_name
          }
        },
        buttons: {
          cancel: {
            text: "Cancelar",
            visible: true
          },
          reset: {
            text: "Resetar",
            value: "reset",
            className: "bg-dark"
          },
          confirm: {
            text: "Salvar"
          }
        }
      }).then(value => {
        if (value === "reset") {
          localStorage.removeItem('operator_name');
          this.$store.state.operator_name = this.operator.name;

        } else if (value) {
          const name = value.trim();

          if (name.length > 2) {
            this.$store.state.operator_name = name;
            localStorage.setItem('operator_name', name);
          }
        }
      });
    }
  },

  mounted() {
    this.buscarContatos(() => {
      if (this.$route.name === 'LebotId') {
        this.selContact(this.$route.params.id, true);
      }

      this.getDepartaments();
      this.checkNotification(true);
    });

    clearInterval(this.synctimeOut);
    setTimeout(() => {
      this.connected = this.$socket ? this.$socket.connected : false;
      this.synctimeOut = setInterval(() => {
        this.buscarContatos();
      }, 1000 * 60 * 3);
    }, 10000);    
  },

  computed: {
    operator() {
      return this.$store.state.dataUser;
    },

    operator_name() {
      return this.$store.state.operator_name;
    },

    session() {
      return this.$store.state.session;
    },

    canPlay() {
     return this.$store.state.canPlay;
    },

    recordingTimeFormatted() {
      const totalSec = this.recordingTime;
      const mm = String(Math.floor(totalSec / 60)).padStart(2, "0");
      const ss = String(totalSec % 60).padStart(2, "0");
      return `${mm}:${ss}`;
    }
  },

  sockets: {
    connect() {
      this.connected = true;
      this.buscarContatos(() => {
        this.sendOffilineMsgs();
      });
    },

    disconnect() {
      if (document.visibilityState !== 'hidden') {
        this.connected = false;
      }
    },

    new_message(message) {
      const contact = this.contacts.find(c => c.id === message.contact_id);

      if (contact) {
        const date = new Date(parseInt(message.send_date) * 1000);
        message.send_date = `${date.getHours()}:${('0'+date.getMinutes()).slice(-2)}`;
        this.moveItem(contact);

        contact.send_date = message.send_date;
        contact.last_message = message.content;
        contact.new_messages = !message.is_me ? (contact.new_messages || 0) + 1 : 0;
        contact.available = 1;
        this.notification();

        if (this.dados.id === contact.id && this.session !== message.session) {
          this.messages.push(message);
          this.dados.available = 1;
          this.$nextTick(() => {
            this.$helpers.scrollView(`msg${this.messages.length - 1}`);
          });
        }

        if (!message.is_me && (this.dados.id !== message.contact_id || document.hidden)) {
          this.playNewMessage();
        }

      } else {
        this.buscarContatos();
      }
    },

    update_message(data) {
      if (data.external_id && data.status) {
        const lebotMessages = document.getElementById('lebotMessages');

        if (lebotMessages) {
          const balao = lebotMessages.querySelector(`[data-id="${data.external_id}"]`);

          if (balao) {
            const el = balao.querySelector('.balao-status');
            if (el) {
              el.classList.remove(`fa-clock`);
              el.classList.add(`${data.status}`);
              el.classList.add(data.errorCode ? 'fa-exclamation-triangle' : 'fa-check');
            }
          }
        }

        if (data.errorCode === 131047) {
          this.$swal("Falha no envio da mensagem porque já se passaram mais de 24 horas desde que o cliente respondeu pela última vez a este número");
        }
      }
    },

    new_chat_order() {
      setTimeout(() => {
        this.buscarContatos(() => {
          this.checkNotification();
        });
      }, 6000);
    }
  },

  beforeDestroy() {
    clearInterval(this.synctimeOut);
    this.cancelRecording();
  },

  beforeRouteLeave(to, from, next) {
    this.pauseNotification();

    if (this.offlineMsgs.length) {
      this.checkOffline();
      next(false);

    } else {
      next();
    }
  },

  watch: {
    $route (to, from){
      this.message = '';

      if (this.offlineMsgs.length) {
        this.checkOffline();

      } else {
        this.selContact(to.params.id, true);
      }
    },

    canPlay(val) {
      if (val) {
        this.checkNotification(true);
      }
    }
  }
}
</script>

<style scoped>
.img-perfil {
  max-width: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.lebot-header {
  border-right: 1px solid #dee2e6;
}

.lebot-contatos-body {
  border-right: 1px solid #dee2e6;
  height: calc(100vh - 56px);
  overflow: auto;
  padding: 0;
}

.lebot-contact {
  display: block;
  padding: 16px 8px;
  border-bottom: 1px solid #dee2e6;
}

.lebot-contact-body {
  width: calc(100% - 70px);
}

.lebot-contact-msg {
  font-size: 13px;
  margin-bottom: 0;
  opacity: 0.7;
}

.lebot-contact .bold h6, .lebot-contact .bold .lebot-contact-msg {
  font-weight: 600!important;
}

.bold .send-date {
  color: var(--primary);
  font-weight: 500;
}

.send-date {
  font-size: 12px;
}

.lebot-contact:hover, .lebot-contact.selected {
  background-color: var(--light);
}

.lebot-conversa {
  position: relative;
}

.lebot-welcome {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lebot-coversas-body {
  overflow: auto;
  height: calc(100vh - 56px);
  background-color: #EFEAE2;
  padding: 16px 38px 76px;
  position: relative;
}

.lebot-coversas-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 12px 20px 12px 6px;
  z-index: 1;
  min-height: 68px;
}

.lebot-coversas-footer .form-control {
  padding: 10px;
  font-size: 14px;
  max-height: 100px;
  min-height: 42px;
}

.btn-scroll {
  position: fixed;
  border-radius: 50%;
  width: 46px;
  height: 46px;
  right: 24px;
  bottom: 92px;
  z-index: 999;
}

.new-message-balao {
  display: inline-block;
  background-color: var(--primary);
  border-radius: 50%;
  color: #fff;
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  padding: 1px 5px 1px;
}

.btn-send {
  flex-grow: 0;
  flex-shrink: 0;
  display: block;
  border-radius: 50%;
  width: 40px;
  height: 40px;
}

.drop-zone {
  position: absolute;
  inset: 0; /* top: 0; right: 0; bottom: 0; left: 0 */
  z-index: 10;
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  opacity: 0;
  pointer-events: none;
  background-color: #f0f9f5;
  transition: border-color 0.3s, background-color 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.drop-zone.active {
  opacity: 1;
  pointer-events: auto;
  border-color: #42b983;
}

.img-preview {
  width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

@media (max-width: 767px) {
  .sel-contato .lebot-contatos {
    display: none;
  }

  .lebot-header {
    border-right: none;
  }

  .lebot-contatos-body {
    min-height: calc(100vh - 56px);
    height: auto;
    border: none;
    overflow: visible;
  }

  .lebot-conversa {
    display: none;
  }

  .lebot-conversa .lebot-header {
    position: fixed;
    border-right: none;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1;
  }

  .lebot-coversas-body {
    padding: 68px 15px 80px;
    height: 100vh;
  }

  .lebot-coversas-footer {
    padding: 11px 8px 14px;
  }

  .sel-contato .lebot-conversa {
    display: block;
  }

  .lebot-coversas-footer .form-control {
    font-size: 16px;
  }
}
</style>
